import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { trackBannerClick, trackBannerShow } from './tracking';
import { DailyrentReviewDesktopModal } from '../../components/DailyrentReviewDesktopModal';
import { DailyrentReviewMobileModal } from '../../components/DailyrentReviewMobileModal';
import { useDailyrentReviewModal } from '../../utils/dailyrent/useDailyrentReviewModal';
import { usePlatform } from '../../utils/platform';
import { useDownloadNativeAppUrl } from '../../utils/useDownloadNativeAppUrl';

export const MOBILE_CAMPAIGN = 'Скачайте приложение, чтобы оставить отзыв_Other'; // "_Other" относится к pageType страницы чатов, https://jira.cian.tech/browse/CD-177903

export const DailyrentReviewModalContainer = () => {
  const { isOpen, closeModal } = useDailyrentReviewModal();
  const deviceType = useDeviceType();
  const platform = usePlatform();
  const downloadNativeAppUrl = useDownloadNativeAppUrl(MOBILE_CAMPAIGN);

  const isDesktop = deviceType === 'desktop';
  const onBannerClick = React.useCallback(() => trackBannerClick(platform), [platform]);

  React.useEffect(() => {
    if (isOpen) {
      trackBannerShow(platform);
    }
  }, [isOpen]);

  if (isDesktop) {
    return <DailyrentReviewDesktopModal isOpen={isOpen} closeModal={closeModal} onDismissClick={closeModal} />;
  }

  return (
    <DailyrentReviewMobileModal
      isOpen={isOpen}
      closeModal={closeModal}
      downloadNativeAppUrl={downloadNativeAppUrl}
      onDownloadClick={onBannerClick}
    />
  );
};
